import { render, staticRenderFns } from "./GemsLabel.vue?vue&type=template&id=6608d07e&"
import script from "./GemsLabel.vue?vue&type=script&lang=js&"
export * from "./GemsLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports